module.exports = "/_next/static/images/bg-info-3b208ec9.png";